(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solvair-horizontal-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solvair-horizontal-rail')) {
    customElements.define('solvair-horizontal-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('focusin', (event) => {
          if (event.target === this || this.scrollWidth <= this.clientWidth) return;
          if (!event.target.matches(':focus-visible')) return;
          const rail = this.getBoundingClientRect();
          const focused = event.target.getBoundingClientRect();
          const style = getComputedStyle(this);
          const left = rail.left + this.clientLeft + (parseFloat(style.scrollPaddingLeft) || 0);
          const right = rail.left + this.clientLeft + this.clientWidth - (parseFloat(style.scrollPaddingRight) || 0);
          if (focused.left < left) {
            this.scrollBy({ left: focused.left - left, behavior: 'instant' });
          } else if (focused.right > right) {
            this.scrollBy({ left: focused.right - right, behavior: 'instant' });
          }
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solvair-privacy-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solvair-privacy-controls')) {
    customElements.define('solvair-privacy-controls', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.querySelector('a').addEventListener('click', async (event) => {
          event.preventDefault();
          const message = this.querySelector('[role="alert"]');
          message.hidden = true;
          try {
            if (typeof window.privacyBanner?.showPreferences !== 'function') {
              throw new Error('Shopify native cookie preferences are not available.');
            }
            await window.privacyBanner.showPreferences();
          } catch (error) {
            console.error('Solvair cookie preferences:', error);
            message.hidden = false;
          }
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solvair-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solvair-sticky-purchase')) {
    customElements.define('solvair-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        const id = this.dataset.sectionId;
        const sourceButton = document.getElementById(`ProductSubmitButton-${id}`);
        const sourcePrice = document.getElementById(`price-${id}`);
        const owner = this.closest('product-info');
        if (!sourceButton || !sourcePrice || !owner) return;
        this.controller = new AbortController();
        const button = this.querySelector('[data-sticky-submit]');
        const priceLabel = this.querySelector('[data-sticky-price]');
        const sync = () => {
          button.disabled = sourceButton.disabled === true || sourceButton.getAttribute('aria-disabled') === 'true';
          button.textContent = (sourceButton.querySelector('span')?.textContent.trim() || sourceButton.textContent.trim()).split('·')[0].trim();
          const price = sourcePrice.querySelector('.price');
          const selector = price?.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular span.price-item--regular';
          const amount = price?.querySelector(selector)?.textContent.trim() || '';
          const priceHidden = sourcePrice.hidden || sourcePrice.classList.contains('hidden') || sourcePrice.classList.contains('visibility-hidden');
          priceLabel.textContent = priceHidden ? '' : amount;
        };
        button.addEventListener('click', () => sourceButton.click(), { signal: this.controller.signal });
        this.mutations = new MutationObserver(sync);
        this.mutations.observe(sourceButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
        this.mutations.observe(sourcePrice, { attributes: true, childList: true, subtree: true, characterData: true });
        let buttonVisible = false;
        let productVisible = false;
        const observeVisibility = () => {
          this.intersections?.disconnect();
          const header = document.querySelector('solvair-header');
          const headerHeight = header?.hasAttribute('data-scroll-hidden')
            ? Math.max(0, header.getBoundingClientRect().bottom)
            : header?.offsetHeight || 0;
          this.intersections = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.target === sourceButton) buttonVisible = entry.isIntersecting && entry.intersectionRatio === 1;
              if (entry.target === owner) productVisible = entry.isIntersecting;
            }
            this.hidden = buttonVisible || !productVisible;
          }, { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: [0, 1] });
          this.intersections.observe(sourceButton);
          this.intersections.observe(owner);
        };
        document.addEventListener('solvair:header-change', observeVisibility, { signal: this.controller.signal });
        observeVisibility();
        sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.mutations?.disconnect();
        this.intersections?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
